import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics measurement ID
const GA_MEASUREMENT_ID = 'G-B45ZF8BSR9';
// Google Tag Manager ID
const GTM_ID = 'GTM-5TMTMX9B';

export function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Initialize Google Analytics
    const loadGAScript = () => {
      // Create the first script (gtag.js)
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      
      // Create the second script (configuration)
      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA_MEASUREMENT_ID}');
      `;
      
      // Add the scripts to the document
      document.head.appendChild(script1);
      document.head.appendChild(script2);
    };

    // Initialize Google Tag Manager
    const loadGTMScript = () => {
      // GTM script for <head>
      const gtmScript = document.createElement('script');
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
      `;
      document.head.insertBefore(gtmScript, document.head.firstChild);

      // GTM noscript iframe for <body>
      const gtmNoScript = document.createElement('noscript');
      const gtmIframe = document.createElement('iframe');
      gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
      gtmIframe.height = '0';
      gtmIframe.width = '0';
      gtmIframe.style.display = 'none';
      gtmIframe.style.visibility = 'hidden';
      gtmNoScript.appendChild(gtmIframe);
      document.body.insertBefore(gtmNoScript, document.body.firstChild);
    };

    loadGAScript();
    loadGTMScript();
  }, []);

  // Track page views when the location changes
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
    
    // Push page view to dataLayer for GTM
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
} 